export default __webpack_public_path__ + "static/media/disposal-sidebar.9f19bf48.svg";